import axios from 'axios';
import localStorageUtils from '../utils/localStoraegUtils';
import {baseURL} from '../config';
import {Modal} from 'antd';

const axiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

axiosInstance.interceptors.request.use((config) => {
  if (config.headers !== undefined) {
    config.headers.Authorization = 'Bearer ' + localStorageUtils.getAccessToken();
    config.headers['organisation-id'] = `${localStorageUtils.getOrganisationId()}`;
    config.headers['user-id'] = `${localStorageUtils.getUserId()}`;
  }

  config.timeout = 10000;
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (response) {
      //perform the manipulation here and change the response object
    }
    return response.data;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        Modal.destroyAll();
        if (window.location.pathname.split('/')[1] !== 'login') {
          Modal.error({
            title: 'Unauthorized  Access',
            content: 'Please login again to continue....',
            onOk() {
              window.location.replace('/login');
            },
          });
        }
        localStorageUtils.removeUser();
      }
      return Promise.reject(error.response.data);
    }
    if (error.code === 'ERR_NETWORK') {
      error.message = 'Network Error , Please check your internet connection.';
      return Promise.reject(error);
    }
    if (error.code === 'ECONNABORTED') {
      error.message = 'Request time out.';
      return Promise.reject(error);
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
